import _regeneratorRuntime from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/myaccountconso/web/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
var __jsx = React.createElement;
import React, { useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { unwrapResult } from '@reduxjs/toolkit';
import { reset, doLogout } from '../login/userSlice';
import Link from 'next/link';
import Image from 'next/image';
import styles from '../styles/header/Drawer.module.scss';
import Button from 'react-bootstrap/Button';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPowerOff, faSpinner } from '@fortawesome/free-solid-svg-icons';
import MobileSubmenu from './MobileSubmenu';

var MobileMenu = function MobileMenu(props) {
  var menuList = props.menuList,
      closeMenu = props.closeMenu;

  var _useState = useState(false),
      isLoading = _useState[0],
      editIsLoading = _useState[1];

  var isLoggedIn = useSelector(function (state) {
    return state.user.isLoggedIn;
  });
  var dispatch = useDispatch();

  var handleLogout = /*#__PURE__*/function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
      var resultAction, response;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              _context.prev = 0;
              editIsLoading(true);
              _context.next = 4;
              return dispatch(doLogout('logout'));

            case 4:
              resultAction = _context.sent;
              response = unwrapResult(resultAction);

              if (response.status) {
                dispatch(reset());
                editIsLoading(false);
              }

              _context.next = 12;
              break;

            case 9:
              _context.prev = 9;
              _context.t0 = _context["catch"](0);
              editIsLoading(false);

            case 12:
            case "end":
              return _context.stop();
          }
        }
      }, _callee, null, [[0, 9]]);
    }));

    return function handleLogout() {
      return _ref.apply(this, arguments);
    };
  }();

  var logoutOption = isLoggedIn && __jsx("li", null, __jsx(Button, {
    onClick: handleLogout,
    variant: "secondary",
    disabled: isLoading ? true : false
  }, __jsx("span", null, isLoading ? __jsx(FontAwesomeIcon, {
    icon: faSpinner,
    className: ""
  }) : __jsx(React.Fragment, null, __jsx(FontAwesomeIcon, {
    icon: faPowerOff,
    className: "mr-3"
  }), "Logout"))), __jsx("hr", {
    className: styles.divider
  }));

  var listHtml = menuList.map(function (item, i) {
    return item.type == 'item' ? __jsx("li", {
      key: i
    }, __jsx(Link, {
      href: item.menuItem.link
    }, __jsx(Button, {
      onClick: closeMenu,
      variant: "secondary"
    }, __jsx("span", null, __jsx(FontAwesomeIcon, {
      icon: item.icon,
      className: "mr-3"
    }), item.menuItem.title))), __jsx("hr", {
      className: styles.divider
    })) : __jsx(MobileSubmenu, {
      key: i,
      submenu: item,
      closeMenu: closeMenu
    });
  });
  return __jsx("div", {
    className: styles.root
  }, __jsx("div", {
    className: styles.back,
    onClick: closeMenu
  }), __jsx("div", {
    className: styles.paperRoot
  }, __jsx("div", {
    className: styles.box
  }, __jsx("div", {
    className: styles.brand
  }, __jsx("span", {
    className: "navbar-brand"
  }, __jsx(Link, {
    href: process.env.NEXT_PUBLIC_WEB
  }, __jsx("a", {
    title: "Conso"
  }, __jsx(Image, {
    src: "/images/icons/conso.png",
    width: 111,
    height: 33,
    alt: "Conso"
  }))))), __jsx("hr", {
    className: styles.divider
  }), __jsx("ul", {
    className: styles.list
  }, listHtml, logoutOption))));
};

export default MobileMenu;